// Chart.js setup and theme-aware options helpers
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
  Decimation,
} from "chart.js";

// Register commonly used components once
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
  Decimation
);

// Make theme-aware chart options with sensible defaults
export function makeThemedOptions(theme, overrides = {}) {
  const mode = theme?.palette?.mode || "light";
  const textPrimary = theme?.palette?.text?.primary || (mode === "dark" ? "#fff" : "#111");
  const textSecondary = theme?.palette?.text?.secondary || (mode === "dark" ? "#ddd" : "#555");
  const gridColor = theme?.palette?.divider || (mode === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)");

  const base = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: { color: textPrimary },
      },
      tooltip: {
        titleColor: textPrimary,
        bodyColor: textPrimary,
        backgroundColor: mode === "dark" ? "rgba(0,0,0,0.72)" : "rgba(255,255,255,0.92)",
        borderColor: gridColor,
        borderWidth: 1,
      },
      decimation: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: { color: gridColor },
        ticks: { color: textSecondary },
      },
      y: {
        grid: { color: gridColor },
        ticks: { color: textSecondary },
      },
    },
  };

  return {
    ...base,
    ...overrides,
    plugins: { ...base.plugins, ...(overrides.plugins || {}) },
    scales: { ...base.scales, ...(overrides.scales || {}) },
  };
}
